module.exports = __webpack_public_path__ + "static/logistics-delivery@3x-70f6a84ce602298c7c1047df02afa978.png";